export const SPEED_ACTION_TYPES = {
  SET_SPEED: 'speed/SET_SPEED',
  SET_IS_SPEED_DROPDOWN_OPEN: 'speed/SET_IS_SPEED_DROPDOWN_OPEN',
};

export const ALGO_SPEED = {
  FAST: 'Fast',
  MEDIUM: 'Medium',
  SLOW: 'Slow',
};
